import { useEffect } from "react";
import { PointerEventCallback } from "../types/pointerEvent";

export const usePointerMove = (on: boolean, callback: PointerEventCallback) => {
  useEffect(() => {
    if (on) {
      let rafHandler: number;

      const handler = (e: PointerEvent) => {
        if (rafHandler !== undefined) {
          window.cancelAnimationFrame(rafHandler);
        }

        rafHandler = window.requestAnimationFrame(() => {
          callback(e);
        });
      };

      window.addEventListener("pointermove", handler);

      return () => {
        if (rafHandler !== undefined) {
          window.cancelAnimationFrame(rafHandler);
        }

        window.removeEventListener("pointermove", handler);
      };
    }
    return undefined;
  }, [callback, on]);
};
